import React from "react";
import { CheckCircle } from "@material-ui/icons";
import { Button } from "@material-ui/core";
import useRedirect from "./useRedirect";

const Activated = ({ activateNext }: { activateNext: () => void }) => {
  const { redirectToNext } = useRedirect();

  return (
    <div className={"activateSec"}>
      <div className={"activatedBox"}>
        <CheckCircle className={"icon"} />
        <div className={"content"}>
          <div className={"line1"}>Activated</div>
          <div className={"line2"}>Check your TV</div>
        </div>
      </div>
      <Button onClick={activateNext} variant="outlined" className={"actionBtn"}>
        Activate Another Device
      </Button>
      <Button
        onClick={redirectToNext}
        variant="outlined"
        className={"actionBtn"}
      >
        Return To SMA Live
      </Button>
    </div>
  );
};

export default Activated;
